import {
  AddressBasedTemplateDetailPage,
  type AddressBasedTemplatePageConfig,
} from "../check-arguments-templates-shared";

const config: AddressBasedTemplatePageConfig = {
  apiPathPrefix: "credit-report",
  settingsPathPrefix: "credit-report-templates",
  templateLabel: (t) => t("Credit report"),
  testIdPrefix: "credit-report-template",
};

export function CreditReportTemplateDetailPage() {
  return <AddressBasedTemplateDetailPage config={config} />;
}
